import { fetchConceptsListTE, fetchModelConceptsListTE, searchConceptsListTE } from 'api/concepts/fetchConceptsList';
import { taskEither } from 'fp-ts';
import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { pipe } from 'fp-ts/lib/function';
import { ReactLeft } from 'utils/uiStates/uiStates';
import { ErrorType, getErrorUiStateKey } from 'utils/uiStates/helpers';

export const onError = (error: Error): ReactLeft<{ reason?: string | undefined }> => ({
  type: getErrorUiStateKey(error as ErrorType),
  props: { reason: error.message },
});

export interface ConceptsParams {
  userId: string;
  appId: string;
  modelId: string;
  versionId: string;
  search?: string;
}

export const conceptsApiEffects = {
  fetchConceptsListTE: (params: ConceptsParams): TaskEither<ReactLeft, CF.API.Concept[]> =>
    pipe(
      fetchConceptsListTE(params, onError),
      taskEither.map((x) => x.concepts),
    ),
  fetchModelConceptsListTE: (params: ConceptsParams): TaskEither<ReactLeft, CF.API.Concept[]> =>
    pipe(
      fetchModelConceptsListTE(params, onError),
      taskEither.map((x) => x.concepts),
    ),
  searchConceptsListTE: (params: ConceptsParams): TaskEither<ReactLeft, CF.API.Concept[]> =>
    pipe(
      searchConceptsListTE(params, onError),
      taskEither.map((x) => x.concepts),
    ),
};
